import * as $ from 'jquery';
import { OnReadyModule } from '../../lib/app-module';
import { langOrDefault } from '../../lib/lang';
import { Lang } from '../../lib/types';
import { initCookieConsent } from './cookie-consent';
import { setupGTag, GTagConfig, GTagLoadFunction } from './gtag';

export interface TrackerConfig {
    gdpr: {enabled: boolean}
    gtag: GTagConfig
}

export class Tracker extends OnReadyModule<TrackerConfig> {
    private gtagLoadFunction: GTagLoadFunction;
    protected override preload(): void {
        const loadGTag = setupGTag(this.config.gtag);

        if (this.config.gdpr.enabled) {
            this.gtagLoadFunction = loadGTag;
        } else {
            loadGTag();
        }
    }

    protected override init(): void {
        if (this.config.gdpr.enabled) {
            initCookieConsent(this.getLang(), this.gtagLoadFunction);
        }
    }

    private getLang(): Lang {
        const pageLang = $('html').attr('lang');
        return langOrDefault(pageLang, 'en');
    }
}